import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {
  createPositionAPI,
  deletePositionAPI,
  updatePositionAPI
} from '../../../../services/position'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
import Error_false from '../../../error/error-false'
import ModalCustom from '../../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../../label-custom'
import Autocomplete from '../../../custom/autocomplete'
const schema = yup
  .object({
    levelId: yup.string().required('Please, Input your level of position.'),
    positionEn: yup.string().required('Please, Input position for English.'),
    positionTh: yup.string().required('Please, Input position for Thai.'),
    headcount: yup.string().required('Please, Input head count.')
    // notebookTypeId: yup.object().required('Please, Input computer type.')
  })
  .required()

export default function AddAndUpdatePosition({
  show,
  onCancel,
  fnGetList,
  data,
  param,
  optionNotebookType
}) {
  const {
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({ resolver: yupResolver(schema) })
  const [isSubmit, setIsSubmit] = useState(false)

  const onSubmit = async (d) => {
    const body = {
      ...d,
      notebookTypeId: d.notebookTypeId?.value ?? ''
    }
    if (data) {
      sendAPI(updatePositionAPI({ ...param, positionId: data.id }, body))
    } else {
      sendAPI(createPositionAPI({ ...param, ...body }))
    }
  }

  useEffect(() => {
    if (data) {
      setValue('levelId', data.level_id ?? '')
      setValue('headcount', data.headcount ?? '') //wait for API
      setValue('positionEn', data.position_en ?? '')
      setValue('positionTh', data.position_th ?? '')

      data.notebook_type_id &&
        setValue('notebookTypeId', {
          label: data.notebook_type_name,
          value: data.notebook_type_id
        })
    }
  }, [data, setValue])

  const fnDelete = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'error',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let body = { positionId: data.id, orgId: param.orgId }
        sendAPI(deletePositionAPI(body))
      }
    })
  }

  const sendAPI = async (api) => {
    setIsSubmit(true)
    const resp = await api
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        onCancel()
        fnGetList()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom width={500} open={show} onCancel={onCancel}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label className="text-primary">{data ? 'Update' : 'Add'} Position</label>
        <Col md={12}>
          <LabelCustom text={'Level'} />
          <Controller
            name={'levelId'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                min={0}
                type="number"
                maxLength={2}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.levelId?.message && (
            <label className="small text-danger">
              {errors.levelId.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Head Count'} />
          <Controller
            name={'headcount'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                min={0}
                type="number"
                maxLength={50}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.headcount?.message && (
            <label className="small text-danger">
              {errors.headcount.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Position EN'} />
          <Controller
            name={'positionEn'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                type="text"
                // pattern="^[A-Za-z\s\-\.\(\)]+$"
                maxLength={100}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.positionEn?.message && (
            <label className="small text-danger">
              {errors.positionEn.message}
            </label>
          )}
        </Col>

        <Col md={12}>
          <LabelCustom text={'Position TH'} />
          <Controller
            name={'positionTh'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control maxLength={100} value={value} onChange={onChange} />
            )}
          />
          {errors.positionTh?.message && (
            <label className="small text-danger">
              {errors.positionTh.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <LabelCustom text={'Computer Type'} />
          <Controller
            name={'notebookTypeId'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <Autocomplete
                options={optionNotebookType}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.notebookTypeId?.message && (
            <label className="small text-danger">
              {errors.notebookTypeId.message}
            </label>
          )}
        </Col>

        <Col xl={12} className="mt-5 text-center">
          <Button className="me-2 px-4" variant="light" onClick={onCancel}>
            Close
          </Button>
          {data && (
            <Button
              disabled={data.count_emp > 0}
              className="me-2 px-4"
              variant="danger"
              onClick={fnDelete}
            >
              Delete
            </Button>
          )}

          <Button className="px-4" disabled={isSubmit} type="submit">
            {!data ? (
              <>Create Permission{isSubmit && '...'}</>
            ) : (
              <>Submit{isSubmit && '...'}</>
            )}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
